// extracted by mini-css-extract-plugin
module.exports = {"langSwitch":"SignInForm_langSwitch__-IuXT"};